import { Component, Prop } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';
import BpcDrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider';
import ContactForm from '@contacts/components/forms/contact-form/contact-form.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFlag } from '@fortawesome/free-solid-svg-icons';
library.add(faFlag);
@Component({
  name: 'bpc-display-contact-link',
  components: {
    'bpc-drawer-modal': BpcDrawerModal,
    'bpc-contact-form': ContactForm,
    'bpc-std-form': StdForm,
  },
})
export default class DisplayContactRelations extends mixins(AbstractDisplayField) {
  $refs: {
    // resourceForm: InstanceType<typeof ResourceForm> & { saveEntity(): void };
    stdForm: InstanceType<typeof StdForm> & {
      saveEntity(): void;
      formModel: any;
      onDeleteMediaFile(): void;
      searchEntity(): void;
      extraData: string | AnyEntity;
      formProvider: EntityFormProvider;
    };
  };

  public entity: any = null;

  public showForm: boolean = false;
  public showDrawerSection: boolean = false;

  public isSavingForm = false;

  public disabledForm = true; // For read only mode when click in code column
  public permissionEntityNameToUse = 'contacts';

  get size(): string {
    return this.fieldConfig?.drawerSize || 'md';
  }

  public onSavingEntity(val) {
    this.isSavingForm = val;
  }

  isVerifiedText(verified) {
    if (verified) {
      return this.$t('contacts.contacts.verified');
    } else {
      return this.$t('contacts.contacts.not_verified');
    }
  }

  whenToInvoice(contact) {
    const whenToInvoice = contact['when_to_invoice_value'] ?? contact['when_to_invoice'];
    switch (whenToInvoice) {
      case 'before':
        return this.$t('contacts.contacts.when_to_invoice.tooltip.before');
      case 'after':
        return this.$t('contacts.contacts.when_to_invoice.tooltip.after');
      case 'undefined':
        return this.$t('contacts.contacts.when_to_invoice.tooltip.undefined');
      default:
        return '';
    }
  }

  clickOnLink(contact) {
    this.entity = contact;
    this.showForm = true;
    this.showDrawerSection = true;
    this.disabledForm = true;
  }
  onFormSave() {
    this.isSavingForm = true;
    console.log('Saving');
    this.$refs.stdForm.saveEntity();
  }

  onFormSaved($event: any = null) {
    this.onFormClose();
    this.$emit('entity-saved');
  }

  onFormClose() {
    this.showForm = false;
    this.showDrawerSection = false;
  }

  get entityName(): string {
    return 'contact';
  }

  get formComponentName(): string {
    return 'bpc-contact-form';
  }

  onFormEdit() {
    this.disabledForm = false;
  }

  getModalTitle() {
    if (this.disabledForm) {
      const title = this.$t('global.models.' + this.entityName + '.name').toString();
      return title.charAt(0).toUpperCase() + title.slice(1); // capitalize
    } else if (this.entity && this.entity.id) {
      return (
        this.$t('global.modals.edit') + ' ' + this.$t('global.models.' + this.entityName + '.name')
      );
    } else {
      return (
        this.$t('global.modals.create') +
        ' ' +
        this.$t('global.models.' + this.entityName + '.name')
      );
    }
  }
}
